export const isNotEmpty = (val) => {
  if (!val || val === "") return "Este campo é obrigatório.";
};

export const VALIDATION_RULES_BY_FIELD = {
  nome: [isNotEmpty],
};
